import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31740739"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { style: {"font-size":"12px","margin-left":"5px"} }
const _hoisted_4 = { class: "box-clum" }
const _hoisted_5 = { class: "text-align-left" }
const _hoisted_6 = { style: {"color":"#1964a6"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_unlock_outlined = _resolveComponent("unlock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t('page.user.register.form.title')), 1)
    ]),
    _createVNode(_component_a_form, { "wrapper-col": {span:24} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, _mergeProps({ label: "" }, _ctx.validateInfos.email), {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.modelRef.email,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.email) = $event)),
              placeholder: _ctx.t('page.user.register.form-item-username'),
              onKeyup: _withKeys(_ctx.handleSubmit, ["enter"])
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_user_outlined)
              ]),
              _: 1
            }, 8, ["value", "placeholder", "onKeyup"])
          ]),
          _: 1
        }, 16),
        _createVNode(_component_a_form_item, _mergeProps({ label: "" }, _ctx.validateInfos.password), {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.modelRef.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.password) = $event)),
              placeholder: _ctx.t('page.user.register.form-item-password'),
              onKeyup: _withKeys(_ctx.handleSubmit, ["enter"])
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_unlock_outlined)
              ]),
              _: 1
            }, 8, ["value", "placeholder", "onKeyup"])
          ]),
          _: 1
        }, 16),
        _createVNode(_component_a_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.checked,
              "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checked) = $event))
            }, null, 8, ["checked"]),
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.t('page.user.register.form.agreement.start')) + " ", 1),
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleGoto('agre')))
              }, _toDisplayString(_ctx.t('page.user.register.form.agreement.agre')), 1),
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleGoto('desc')))
              }, _toDisplayString(_ctx.t('page.user.register.form.agreement.desc')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              class: "submit",
              onClick: _ctx.handleSubmit,
              loading: _ctx.submitLoading,
              disabled: _ctx.disabled
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('page.user.register.form.btn-submit')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading", "disabled"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/user/login" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('page.user.register.form.btn-jump')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.errorMsg !== '' && typeof _ctx.errorMsg !== 'undefined' &&  !_ctx.submitLoading)
          ? (_openBlock(), _createBlock(_component_a_alert, {
              key: 0,
              message: _ctx.errorMsg,
              type: "error",
              "show-icon": true
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}